<template>
  <div class="container-fluid px-0 bg-gray-200 h-100">
    <div class="d-flex flex-row mnh-100">
      <v-menu v-if="!hasSignature" />
      <div class="container px-0">
        <v-header
          class="position-relative"
          style="z-index: 30"
        />
        <section
          class="margin-menu mx-auto w-100"
          :class="`container-${isToolBarOpen ? 'open' : 'close'}`"
        >
          <transition
            name="fade"
            mode="out-in"
            tag="div"
          >
            <router-view />
          </transition>
        </section>
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import { ui } from '@/mixins';
import Menu from '@/components/common/layout/DashboardMenu.vue';
import Header from '@/components/common/layout/Header.vue';

export default {
  name: 'DashboardClient',
  components: {
    'v-menu': Menu,
    'v-header': Header,
  },
  mixins: [ui],
  computed: {
    ...mapGetters({
      signatures: 'company/signatures',
      isToolBarOpen: 'ui/isToolBarOpen',
    }),
    hasSignature() {
      if (this.signatures && this.signatures.length > 0) {
        return this.signatures.some((signature) => signature.status === 'WAITING');
      } return false;
    },
  },
};
</script>
<style scoped>
@media screen and (max-width: 992px) {
  .margin-menu {
    margin-bottom: 70px;
  }
}
@media (min-width: 992px) {
  .container-open { max-width: calc(992px - 250px); }
  .container-close { max-width: calc(992px - 90px); }
}

@media (min-width: 1200px) {
  .container-open { max-width: calc(1200px - 250px); }
  .container-close { max-width: calc(1200px - 90px); }
}

@media (min-width: 1400px) {
  .container-open { max-width: calc(1400px - 250px); }
  .container-close { max-width: calc(1400px - 90px); }
}
</style>
